import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { getOnboardingPath, getRegPath } from "../../../constants";
import * as actions from "../../../store/actions/";
import { VALIDATE_LOGIN } from "../../../store/actions/actionTypes";

import "./index.css";
import Row from "../../../components/uiElements/grid/Row";
import Button from "../../../components/formElements/button/Button";
import TextInput from "../../../components/formElements/input/TextInput";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";
import Modals from "../../../components/uiElements/popupModal/modal";
import { getRole, getUserData } from "../../../utils/localStorage";
import LoginModel from "../../../components/uiElements/modal/LoginModal";

const SignIn = ({
  loginData,
  setLoginData,
  form,
  validateData,
  history,
  login,
  apiUtil,
}) => {
  const [error, setError] = useState();
  const [loginModal, setLoginModal] = useState(false);

  

  useEffect(() => {
    if (form && form.loginValid) {
      login(error => {
        if (error) {
          setError(error);
        } else {
          getRole() === "PHYSICIAN" &&
            localStorage.setItem("loginLoading", true);
          ((getRole() === "PHYSICIAN" &&
            !["PENDING", "DENIED"].includes(getUserData()?.doctor_status)) ||
            getRole() === "PATIENT") &&
            history.push(getOnboardingPath(""));
        }
      });
      form.loginValid = false;
    }
    // eslint-disable-next-line
  }, [form]);

  return (
    <>
     {loginModal && (
        <LoginModel
          isOpen={loginModal}
          onSuccess={() => {
            validateData(loginData)
          }}
          closeModal={() => setLoginModal(!loginModal)}
        />
      )}
    
      <Modals
        isOpen={error}
        closeModal={() => setError(undefined)}
        onBackdropClick={true}
        styles={{
          content: {
            minWidth: "450px",
            maxWidth: "450px",
          },
        }}
        title={"Login Error"}
        btnDark={{
          label: "Okay",
          onclick: () => setError(undefined),
        }}
      >
        <React.Fragment>
          <button
            onClick={() => setError(undefined)}
            className="close fileClose"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p className="mx-auto text-center denyAppointmentText font-weight-bold">
            {error}
          </p>
        </React.Fragment>
      </Modals>
 
      <div className="container" style={{ marginTop: "10%", maxWidth: 400 }}>
        <h2 className="auth-header mb-5">
          Account
          <br />
          Sign In as {""}
          {getRole().charAt(0).toUpperCase() +
            getRole().toLocaleLowerCase().slice(1)}
        </h2>
        <Row>
          <div
            className="col-md-12 text-left mt-4"
            onKeyDown={event => {
              if (event.keyCode === 13) {
                validateData(loginData);
              }
            }}
          >
            <TextInput
              error={form.loginEmail}
              type="text"
              label="Email Id"
              value={loginData.email}
              onChange={val => setLoginData({ email: val })}
            />
            <TextInput
              error={form.loginPassword}
              type="password"
              label="Password"
              value={loginData.password}
              onChange={val => setLoginData({ password: val })}
            />
            <Link
              className="forgot-password float-right"
              to={getRegPath("/forgot-password")}
            >
              Forgot Password?
            </Link>
          </div>
        </Row>
        <div>
          <Button
            label={apiUtil.isLoading ? <SpinnerBorder /> : "Sign In"}
            className="mb-3"
          onClick={()=>setLoginModal(true)}
           />
        
        <div className="row w-75 mx-auto">
            <div className="col">
              <hr />
            </div>
            <div className="col-auto" style={{ color: " #828282" }}>
              OR
            </div>
            <div className="col">
              <hr />
            </div>
          </div>
          <Button
            type="outline"
            label="Register"
            onClick={() => history.push(getRegPath("/signup"))}
          />
        </div>
        <p className="text-center mt-4">
          <Link className="link font-weight-bold" to={getRegPath("/")}>
            Back to user selection
          </Link>
        </p>
      </div>
      
    </>
  );
};

const mapStoreToProps = ({ login, validation, api }) => ({
  loginData: login,
  form: validation.data,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setLoginData: updatedData => dispatch(actions.setLoginData(updatedData)),
  validateData: loginData =>
    dispatch(actions.validateData(VALIDATE_LOGIN, loginData)),
  login: cb => dispatch(actions.login(cb)),
});

export default withRouter(connect(mapStoreToProps, mapDispatchToProps)(SignIn));
